import { LazyFallback } from 'components/shared/LazyFallback';
import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const BatchWorkspaceRouteLazy = lazyWithRetry(() => import('./BatchWorkspace'));
export function BatchWorkspaceRoute() {
  return (
    <Suspense fallback={<LazyFallback />}>
      <BatchWorkspaceRouteLazy />
    </Suspense>
  );
}
